import { render, staticRenderFns } from "./memberAwardEditor.vue?vue&type=template&id=bdb1c366&"
import script from "./memberAwardEditor.vue?vue&type=script&lang=js&"
export * from "./memberAwardEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdb1c366')) {
      api.createRecord('bdb1c366', component.options)
    } else {
      api.reload('bdb1c366', component.options)
    }
    module.hot.accept("./memberAwardEditor.vue?vue&type=template&id=bdb1c366&", function () {
      api.rerender('bdb1c366', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/components/memberAwardEditor.vue"
export default component.exports